export const getTimestamp = (): number => Math.floor(Date.now() / 1000);

export const getConceptIdFromUrl = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('diagnose');
};
